import { i18n } from '~/app/i18n';

import {
  DEFAULT_AGENT_COMPOSER_SESSION_TITLE,
  DEFAULT_AGENT_COMPOSER_SESSION_TITLE_I18N_KEY,
} from './agentComposerSessionTypes';

export const LEGACY_AGENT_COMPOSER_SESSION_TITLES = [
  'Agent chat',
  'New Chat',
] as const;

export const isUnsetAgentComposerSessionTitle = (
  title: string | undefined | null
): boolean => {
  const trimmed = title?.trim();
  if (!trimmed || trimmed === DEFAULT_AGENT_COMPOSER_SESSION_TITLE) {
    return true;
  }
  return LEGACY_AGENT_COMPOSER_SESSION_TITLES.includes(
    trimmed as (typeof LEGACY_AGENT_COMPOSER_SESSION_TITLES)[number]
  );
};

export const getDefaultAgentComposerSessionTitle = (): string =>
  i18n.t(DEFAULT_AGENT_COMPOSER_SESSION_TITLE_I18N_KEY, { ns: 'studio' });

export const resolveAgentComposerSessionTitleForDisplay = (
  title: string | undefined | null
): string => {
  if (isUnsetAgentComposerSessionTitle(title)) {
    return getDefaultAgentComposerSessionTitle();
  }
  return title!.trim();
};
